// TODO: improve types of utils
type StoreType = {
  fetch: any;
  fetchMore: any;
  list: any;
};

export function shouldRejectRequest(
  store: StoreType,
  waitForInitialFetch = true,
) {
  if (
    store.list.isEmpty ||
    store.list.hasNoMore ||
    store.fetchMore.inProgress ||
    store.fetchMore.isError ||
    (waitForInitialFetch &&
      !store.fetch.hasEverBeenRun &&
      store.fetch.inProgress)
  ) {
    return true;
  }

  return false;
}

type ListStoreType = {
  fetch: any;
  fetchMore: any;
};

export function shouldRejectPagination(list: ListStoreType) {
  return shouldRejectRequest({
    list: list,
    fetch: list.fetch,
    fetchMore: list.fetchMore,
  });
}

export async function handleFlow(flow: any, promise: any) {
  try {
    flow.start();

    const res = await promise();

    flow.success();

    return res;
  } catch (error) {
    flow.failed(error, true);
  }
}
